import { EmailStatus } from '@tribeplatform/gql-client/types'

export const emailStatusMapping = {
  [EmailStatus.CREATED]: {
    className: 'text-gray-600',
    title: 'Queued',
    description: 'We are preparing the email to be sent',
  },
  [EmailStatus.PROCESSED]: {
    className: 'text-gray-600',
    title: 'Sending',
    description: 'We are sending out this email',
  },
  [EmailStatus.DEFERRED]: {
    className: 'text-yellow-600',
    title: 'Deferred',
    description:
      "We couldn't deliver the email immediately, we will retry sending this email a few more times",
  },
  [EmailStatus.BOUNCED]: {
    className: 'text-red-600',
    title: 'Bounced',
    description:
      'The email was bounced. Most likely the email address is incorrect or no longer exists',
  },
  [EmailStatus.BLOCKED]: {
    className: 'text-red-600',
    title: 'Blocked',
    description: 'The email was blocked by the receiving email server',
  },
  [EmailStatus.DROPPED]: {
    className: 'text-red-600',
    title: 'Dropped',
    description: 'We did not send the email',
  },
  [EmailStatus.SENT]: {
    className: 'text-green-600',
    title: 'Sent',
    description: 'The email was sent successfully on our end',
  },
  [EmailStatus.DELIVERED]: {
    className: 'text-green-600',
    title: 'Delivered',
    description: 'The email was delivered successfully on our end',
  },
}
